import { useState } from "react";
import { Container } from "react-bootstrap";
import {
  FaUser,
  FaCalendarAlt,
  FaChartLine,
  FaChevronRight,
} from "react-icons/fa";
import "../../styles/MentorShip.css";

const formats = [
  {
    icon: <FaUser />,
    title: "One-Time Mentorship",
    desc: "Focused, personalized guidance on specific career goals or challenges—tailored to your current stage and aspirations.",
    more: "Ideal for quick clarity, decision-making support, resume reviews, or targeted career advice in a single focused session.",
  },
  {
    icon: <FaCalendarAlt />,
    title: "Series Mentorship",
    desc: "Focused, personalized guidance on specific career goals or challenges—tailored to your current stage and aspirations.",
    more: "Perfect for structured growth over multiple sessions with clear milestones and accountability.",
  },
  {
    icon: <FaChartLine />,
    title: "Ongoing Mentorship",
    desc: "Focused, personalized guidance on specific career goals or challenges—tailored to your current stage and aspirations.",
    more: "Long-term partnership with continuous guidance, feedback, and career strategy alignment.",
  },
];

const MentorshipFormats = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleCard = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="mentorship-formats-section">
      <Container>
        <h2 className="mentor-section-title wise-secondary-gradient">
          MENTORSHIP FORMATS
        </h2>
        <p className="text-secondary mentor-section-subtitle">
          Three flexible formats designed for meaningful outcomes
        </p>

        {formats.map((item, index) => {
          const isOpen = activeIndex === index;

          return (
            <div
              key={index}
              className={`mentor-format-card hover-effect-only ${isOpen ? "active" : ""}`}
              onClick={() => toggleCard(index)}
            >
              <div className="mentor-icon-box">{item.icon}</div>

              <div className="text-secondary format-content">
                <h5>{item.title}</h5>
                <p>{item.desc}</p>
                {isOpen && <p className="format-more">{item.more}</p>}
              </div>

              <FaChevronRight
                className={`mentor-arrow-icon ${isOpen ? "rotate" : ""}`}
              />
            </div>
          );
        })}
      </Container>
    </section>
  );
};

export default MentorshipFormats;
